export default __webpack_public_path__ + "static/media/group-badge.107affc6.svg";